import React, { FC, useEffect } from 'react'
import { TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { DataLoader } from './ConfirmDataLoader'
import { TerminateContractErrorHandler } from '../TerminateContractErrorHandler'
import { ContractTerminationRequestPreview } from './ContractTerminationRequestPreview'
import { ConfirmContractTerminationForm } from './ConfirmForm'
import { ConfirmSuccess } from './Success'
import { resolveContractTerminationTerminology } from '../../ContractChanges/utils/resolveContractTerminationTerminology'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const ConfirmContractTermination: FC = () => {
  const { t } = useTranslation(['common', 'terminateContract', 'titles'])
  const [view, setView] = React.useState<'default' | 'success'>('default')
  const [params] = useSearchParams()
  const { frontPagePath } = useContractPaths()

  useEffect(() => {
    if (params.get('success')) {
      setView('success')
    }
  }, [params, setView])

  return (
    <TitleController title={t('terminateContract:headings.confirmation')}>
      <ResidentAppView
        title={t('terminateContract:headings.confirmation')}
        backLink={
          <ResidentAppBackLink href={frontPagePath}>
            {t('common:views.home')}
          </ResidentAppBackLink>
        }
      >
        <ResidentAppCard>
          <TerminateContractErrorHandler view="confirm">
            <DataLoader>
              {(data) => (
                <>
                  {view === 'success' && (
                    <ConfirmSuccess contractType={data.contract.contractType} />
                  )}
                  {view === 'default' && (
                    <ConfirmContractTerminationForm
                      contractTerminationRequestId={
                        data.contractTerminationRequest.id
                      }
                      contractType={data.contract.contractType}
                      userMetadata={data.userMetadata}
                    >
                      <ContractTerminationRequestPreview
                        contractTerminationRequest={
                          data.contractTerminationRequest
                        }
                        tenants={data.tenants}
                        contract={data.contract}
                        confirmButtonLabel={t(
                          resolveContractTerminationTerminology(
                            data.contract.contractType
                          ).confirmButton
                        )}
                      />
                    </ConfirmContractTerminationForm>
                  )}
                </>
              )}
            </DataLoader>
          </TerminateContractErrorHandler>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
